export default "__VITE_ASSET__Hnmy$A4z__"